import { motion } from "framer-motion";
import { ReactNode } from "react";

export interface SectionProps {
  eyebrow?: string;
  title: string;
  children: ReactNode;
  id?: string;
}

export function Section({ eyebrow, title, children, id }: SectionProps) {
  return (
    <motion.section
      id={id}
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="mx-auto w-full max-w-6xl px-4 py-12 lg:px-8 lg:py-16"
    >
      {eyebrow && <div className="section-eyebrow mb-2">{eyebrow}</div>}
      <h2 className="section-title mb-6">{title}</h2>
      <div className="prose-nsm space-y-4">{children}</div>
    </motion.section>
  );
}
